$(document).on("change", ".htmldoc-page .checkbox .item-replayable", (e) => updateHtmlDoc(e.target, "replayable"));
$(document).on("change", ".htmldoc-page .checkbox .item-show_score", (e) => updateHtmlDoc(e.target, "show_score"));
$(document).on("change", ".htmldoc-page .checkbox .item-show_validation", (e) => updateHtmlDoc(e.target, "show_validation"));

const updateHtmlDoc = (target, field_name) => {
  const url = target.dataset.actionPath;
  const data = { html_doc: { [field_name]: target.checked } };

  ajax({
    method: "put",
    url: url,
    data: data,
    error: function (e) {
      console.error(e);
      window.location.reload();
    },
  });
};
